export const sortOptions: { title: string; value: string }[] = [
	{ title: 'Latest Added', value: 'updatedAt-desc' },
	{ title: 'Most Used', value: 'used-desc' },
	{ title: 'Least Used', value: 'used-asc' },
	{ title: 'A - Z', value: 'name-asc' },
	{ title: 'Z - A', value: 'name-desc' },
];
